<!--
 * @Author       : NN
 * @Date         : 2020-08-04
 * @Description  : 优惠券列表
 -->
<template>
	<div class="fund_manage couponBox">
		<a-tabs :activeKey="activeKey" @change="handCut">
			<a-tab-pane tab="优惠券列表" key="1">
				<!-- 搜索 -->
				<div class="search">
					<a-form layout="inline">
						<a-form-item>
							<a-select allowClear placeholder="请选择优惠券类型" style="width: 195px" v-model="coupon_type">
								<a-select-option v-for="(item, i) in coupon_list" :key="i" :value="i">{{ item }}</a-select-option>
							</a-select>
						</a-form-item>

						<a-form-item>
							<a-select allowClear placeholder="是否过期" style="width: 195px" v-model="is_end">
								<a-select-option :value="1">过期</a-select-option>
								<a-select-option :value="2">未过期</a-select-option>
							</a-select>
						</a-form-item>

						<a-form-item><a-input allowClear style="width:300px;" placeholder="请输入优惠券名称" v-model="coupon_name" /></a-form-item>

						<a-form-item><a-button @click="resetGoods">重置</a-button></a-form-item>

						<a-form-item><a-button type="primary" html-type="submit" @click="getList({page: 1})">查询</a-button></a-form-item>
					</a-form>
				</div>

				<!-- 操作栏 -->
				<div class="handle"><a-button type="primary" @click="onNavJump('coupon/add')">发行优惠券</a-button></div>

				<!-- 表格 -->
				<div id="tableHeight">
					<a-table
					    v-if="tableHeight>0"
						:loading="loading"
						:columns="columns"
						:dataSource="dataSource"
						:row-key="record => record.id"
						:pagination="pagination"
						@change="onChangeload"
						:scroll="{ x: 1540, y: tableHeight }"
					>
						<span slot="money" slot-scope="text">
							<span style="color: #FC5454;">{{text.money>0?text.money:(text.discount+'折')}}</span>
						</span>
						
						<span slot="status" slot-scope="text">
							{{text.status==3?'是':'否'}}
						</span>
						
						<span slot="valid_time" slot-scope="text">
							<span style="display: block;white-space: nowrap;">{{text.start_time}}</span>
							<span style="display: block;white-space: nowrap;">{{text.end_time}}</span>
						</span>

						<span slot="isShow" slot-scope="text">
							<a-switch :default-checked="text.is_display==1" @change="changeShow(text.id,text.is_display)" />
						</span>
					
						<span slot="action" slot-scope="text">
							<div class="handleBox">
								<template v-if="text.status != 3">
									<a href="javascript:;" @click="onNavJump('coupon/edits/'+text.id)">编辑</a>
									<a-divider type="vertical" />
									<a href="javascript:;" @click="giftCoupon(text.id)">赠券</a>
									<a-divider type="vertical" />
									<a-dropdown>
										<a class="ant-dropdown-link" @click="e => e.preventDefault()">
											更多
											<a-icon type="down" />
										</a>
										<a-menu slot="overlay">
										<a-menu-item>
											<a href="javascript:;" @click="onNavJump('coupon/record/'+text.id)">领取记录</a>
										</a-menu-item>
										<a-menu-item>
											<a href="javascript:;" @click="onNavJump('coupon/giftSee/'+text.id)">赠送记录</a>
										</a-menu-item>
										<a-menu-item>
											<a href="javascript:;" @click="delCoupon(text.id)">删除</a>
										</a-menu-item>
										</a-menu>
									</a-dropdown>
								</template>
								<template v-else>
									<a href="javascript:;" @click="onNavJump('coupon/see/'+text.id)">查看</a>
									<a-divider type="vertical" />
									<a href="javascript:;" @click="delCoupon(text.id)">删除</a>
									<a-divider type="vertical" />

								<a-dropdown>
									<a class="ant-dropdown-link" @click="e => e.preventDefault()">
										更多
										<a-icon type="down" />
									</a>
									<a-menu slot="overlay">
										<a-menu-item>
											<a href="javascript:;" @click="onNavJump('coupon/record/'+text.id)">领取记录</a>
										</a-menu-item>
										<a-menu-item>
											<a href="javascript:;" @click="onNavJump('coupon/giftSee/'+text.id)">赠送记录</a>
										</a-menu-item>
										</a-menu>
									</a-dropdown>
								</template>
							</div>
						</span>
					</a-table>
				</div>
				
				<a-modal
				      title="删除优惠券"
				      :visible="deleteVisible"
				      :confirm-loading="deleteLoading"
				      @ok="deleteOk"
				      @cancel="deleteVisible = false"
				    >
				      <p>是否确认删除当前优惠券！</p>
				    </a-modal>
			</a-tab-pane>
			
			<a-tab-pane tab="优惠券设置" key="2">
				<a-form class="boxs" :form="form1" style="padding-top: 40px;">
				  <a-form-item label="是否自动清除过期优惠券：" :label-col="{ span: 4 }" :wrapper-col="{ span: 12 }">
				    <div>
						<a-switch :checked="couponChecked" v-decorator="['couponChecked']" @change="changeCoupon" />
						<span>（这个是指自动清除前端用户已失效的优惠券记录）</span>
					</div>
					<div class="dateBox" v-if="couponChecked">
						优惠券过期后
						<div>
							<a-input v-model="coupon_date" type="number" min="0"/>
						</div>
						天，系统自动清除。
					</div>
				  </a-form-item>
				  <a-form-item label="是否自动清除过期活动：" :label-col="{ span: 4 }" :wrapper-col="{ span: 12 }">
				    <div>
						<a-switch :checked="activeChecked" v-decorator="['activeChecked']" @change="changeActive" />
						<span>（这个是指自动清除优惠券列表的已过期记录）</span>
					</div>
					<div class="dateBox" v-if="activeChecked">
						活动过期后
						<div>
							<a-input v-model="active_date" type="number" min="0"/>
						</div>
						天，系统自动清除。
					</div>
				  </a-form-item>
				  <a-form-item label="限领设置：" :label-col="{ span: 4 }" :wrapper-col="{ span: 12 }">
				    <a-radio-group v-decorator="['radioGroup', { initialValue: checkRadio }]" @change="radioChange">
				        <a-radio :value="0">
				          每人限领1张
				        </a-radio>
				        <a-radio :value="1">
				          每人可领多张
				        </a-radio>
				      </a-radio-group>
				  </a-form-item>
				</a-form>
				
				<div class="foot">
				  <a-button type="primary" @click="onSave">保存</a-button>
				</div>
				
				<a-spin v-if="loading" class="spinM" :spinning="loading"></a-spin>
			</a-tab-pane>
		</a-tabs>

		<a-modal
			title="赠券"
			:visible="giftVisible"
			:confirm-loading="giftLoading"
			@ok="giftOk"
			@cancel="giftVisible = false"
			width="920px"
		>
			<div class="giftMaskBox">
				<div class="giftMaskBox_left">
					<span class="red">*</span>
					赠送对象：
				</div>
				<div class="giftMaskBox_right">
					<div class="tabs">
						<div :class="{active: giftMaskIndex == 0}" @click="giftMaskIndex = 0">选择会员</div>
						<div :class="{active: giftMaskIndex == 1}" @click="giftMaskIndex = 1">已选会员</div>
					</div>

					<template v-if="giftMaskIndex == 0">
						<div class="searchBox">
							<a-select allowClear placeholder="请选择会员级别" style="width: 160px" v-model="grade">
								<a-select-option v-for="item,index of grade_list" :key="index" :value="item.id">{{ item.name }}</a-select-option>
							</a-select>
							<a-input allowClear style="width:280px;" placeholder="请输入会员ID/会员名称/手机号" v-model="name" />
							<a-button @click="reset">重置</a-button>
							<a-button type="primary" @click="query">查询</a-button>
						</div>

						<div style="position: relative;border: 1px solid #E9ECEF;">
							<a-table :columns="columnsM" @change="onChangeloadM" :row-key="record => record.id" :data-source="user_list" :pagination="paginationM" :row-selection="{ selectedRowKeys: selectedRowKeysM, onChange: onSelectChangeM }" :scroll="{ x: 700,y: 200 }">
							</a-table>

							<div style="position: absolute;bottom: 22px;left: 20px;z-index: 99">
								已选<span style="margin: 0 5px;color: #03A2F4;">{{check_list.length}}</span>位用户
							</div>
						</div>
					</template>

					<div v-else style="position: relative;border: 1px solid #E9ECEF;margin-top: 20px;">
						<a-table :columns="columnsM1" @change="onChangeloadM" :row-key="record => record.id" :data-source="check_list" :pagination="paginationM" :scroll="{ x: 700,y: 200 }">
							
							<div slot="handle" slot-scope="text">
								<a @click="delCheck(text)" href="javascript:;" style="color: #03A2F4;">删除</a>
							</div>
						</a-table>

						<div style="position: absolute;bottom: 22px;left: 20px;z-index: 99">
							共<span style="margin: 0 5px;color: #03A2F4;">{{check_list.length}}</span>位用户
						</div>
					</div>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
import $ from 'jquery'

const columns = [
	{
		title: 'ID',
		key: 'id',
		dataIndex: 'id',
		width: 90,
		fixed: 'left'
	},
	{
		title: '优惠券名称',
		key: 'name',
		dataIndex: 'name',
		width: 150
	},
	{
		title: '类型',
		key: 'activity_type',
		dataIndex: 'activity_type',
		width: 100
	},
	{
		title: '可用范围',
		key: 'type',
		dataIndex: 'type',
		width: 120
	},
	{
		title: '使用门槛',
		key: 'z_money',
		dataIndex: 'z_money',
		width: 120
	},
	{
		title: '面值',
		key: 'money',
		scopedSlots: { customRender: 'money' },
		width: 120
	},
	{
		title: '总发行量',
		key: 'circulation',
		dataIndex: 'circulation',
		width: 100
	},
	{
		title: '剩余数量',
		key: 'num',
		dataIndex: 'num',
		width: 100
	},
	{
		title: '是否过期',
		key: 'status',
		scopedSlots: { customRender: 'status' },
		width: 90
	},
	{
		title: '是否显示',
		key: 'isShow',
		scopedSlots: { customRender: 'isShow' },
		width: 90
	},
	{
		title: '有效时间',
		key: 'valid_time',
		scopedSlots: { customRender: 'valid_time' },
		width: 170
	},
	{
		title: '操作',
		key: 'action',
		scopedSlots: { customRender: 'action' },
		width: 200,
		fixed: 'right'
	}
];

const columnsM = [
	{
		title: '会员ID',
		key: 'user_id',
		dataIndex: 'user_id',
		width: 170,
		fixed: 'left'
	},
	{
		title: '会员名称',
		key: 'user_name',
		dataIndex: 'user_name',
		width: 170
	},
	{
		title: '手机号',
		key: 'mobile',
		dataIndex: 'mobile',
		width: 170
	},
	{
		title: '会员等级',
		key: 'grade_name',
		dataIndex: 'grade_name',
		width: 170
	},
];

const columnsM1 = [
	{
		title: '会员ID',
		key: 'user_id',
		dataIndex: 'user_id',
		width: 168,
		fixed: 'left'
	},
	{
		title: '会员名称',
		key: 'user_name',
		dataIndex: 'user_name',
		width: 168,
	},
	{
		title: '手机号',
		key: 'mobile',
		dataIndex: 'mobile',
		width: 168
	},
	{
		title: '会员等级',
		key: 'grade_name',
		dataIndex: 'grade_name',
		width: 168
	},
	{
		title: '操作',
		width: 70,
		scopedSlots: { customRender: 'handle' },
	},
];

const columns3 = [
	{
		title: '会员ID',
		key: 'id',
		dataIndex: 'id',
		width: 150,
		fixed: 'left'
	},
	{
		title: '手机号',
		key: 'name',
		dataIndex: 'name',
		width: 270
	},
	{
		title: '赠送总量',
		key: 'circulation',
		dataIndex: 'circulation',
		width: 270
	},
	{
		title: '优惠券类型',
		key: 'activity_type',
		dataIndex: 'activity_type',
		width: 270
	},
	{
		title: '赠送时间',
		key: 'valid_time',
		scopedSlots: { customRender: 'valid_time' },
		width: 270
	},
	{
		title: '操作',
		key: 'action',
		scopedSlots: { customRender: 'action' },
		width: 150,
		fixed: 'right'
	}
];

export default {
	data() {
		return {
			columns,
			columns3,
			columnsM1,
			form: this.$form.createForm(this, { name: 'deliver' }), // 搜索form
			form1: this.$form.createForm(this, { name: 'config' }), // 搜索form
			activeKey: "1",

			// 搜索
			coupon_type: undefined,
			coupon_list: [],
			is_end: undefined,
			coupon_name: '',

			// 表格
			loading: true,
			selectedRowKeys: [],
			selectedRow: [],
			dataSource: [],
			pagination: {},
			
			// 优惠券设置
			couponChecked: true,
			coupon_date: '',
			activeChecked: true,
			active_date: '',
			checkRadio: 0,
			
			deleteId: '',
			deleteVisible: false,
			deleteLoading: false,
			tableHeight: 0,

			giftVisible: false,
			giftLoading: false,
			giftMaskIndex: 0,
			name: '',
			grade: undefined,
			maskSearchData: {},
			grade_list: [],
			user_list: [],

			selectedRowKeysM: [],
			selectedRowM: [],
			columnsM,
			pageM: 1,
			coupon_id: '',
			paginationM: {
				current: 1,
				total: 0,
			},
			check_list: [],
			coupon_num: 0,

			clickFlag: true
		};
	},
	watch: {
		giftMaskIndex(val){
			if(val == 1){
				this.paginationM = {
					current: 1,
					total: this.check_list.length,
				}
			}else{
				this.paginationM = {
					current: 1,
					total: 0,
				}
				this.maskSearchData = {}

				this.grade = undefined
				this.name = ''
				this.userAxios()
			}
		}
	},
	created() {
		this.getList({page: 1})
		
		this.$nextTick(()=>{
			setTimeout(()=>{
				this.getTableHeight();
			},1)
		})
	},
	methods: {
		changeShow(id,is_display){
			if(!this.clickFlag){
				return
			}
			this.clickFlag = false

			let data = {
				id: id,
				is_display: is_display==1?0:1
			}
			let url = '?module=pc_api&action=coupon&app=is_display';
			this.$request.post(url, data).then(res => {
				if(res.code == 200){
					this.$message.success(res.message);
					this.getList({page: 1})
				}else{
					this.$message.error(res.message);
				}

				this.clickFlag = true
				console.log(this.clickFlag)
			})
		},
		giftCoupon(id){
			this.coupon_id = id
			
			this.giftLoading = false

			this.paginationM = {
				current: 1,
				total: 0,
			}
			this.maskSearchData = {}

			this.grade = undefined
			this.name = ''
			this.selectedRowKeysM = []
			this.selectedRowM = []
			this.check_list = []
			this.userAxios()
		},
		delCheck(item){
			let index = this.check_list.findIndex(it=>{
				return it.id == item.id
			})

			this.check_list.splice(index,1)
		},
		onChangeloadM(pagination) {
			console.log(pagination)
			this.paginationM = {...pagination}

			if(this.giftMaskIndex == 1){
				return
			}
			this.userAxios()
		},
		reset(){
			this.maskSearchData = {}

			this.grade = undefined
			this.name = ''
		},
		query(){
			this.maskSearchData = {
				grade: this.grade,
				name: this.name
			}

			this.paginationM = {
				current: 1,
				total: 0,
			}

			this.selectedRowKeysM = []
			this.selectedRowM = []

			this.page = 1;
			this.userAxios();
		},
		userAxios(){
			let data = {
				coupon_activity_str: this.coupon_id, // 优惠券活动ID
				...this.maskSearchData,
				page: this.paginationM.current, // 页码
				pagesize: 10,
			}

			let url = '?module=pc_api&action=coupon&app=get_user';
			this.$request.post(url, data).then(res => {
				let { code, message, data } = res;
				if(code == 200){
					this.giftVisible = true;
					this.grade_list = data.grade_lsit;
					this.paginationM.total = Number(data.total);
					this.coupon_num = data.num

					this.user_list = data.user_lsit;

					this.selectedRowKeysM = [];
					this.selectedRowM = [];

					if(res.data.user_lsit && res.data.user_lsit.length>0){
						res.data.user_lsit.filter((item,index)=>{
							this.check_list.filter(it=>{
								if(it.id == item.id){
									this.selectedRowKeysM.push(item.id)
									this.selectedRowM.push(item)
								}
							})
						})
					}

					console.log(this.selectedRowKeysM)

				}else{
					this.$message.error(message);
				}
			});
		},
		giftOk(){
			if(this.check_list.length>this.coupon_num){
				this.$message.error('优惠券数量不足');
				return
			}

			let user_str = ''
			this.check_list.filter(item=>{
				user_str += ',' + item.id
			})
			user_str = user_str.replace(',','')
			this.giftLoading = true

			let url = '?module=pc_api&action=coupon&app=give';
			let data = {
				coupon_activity_str: this.coupon_id,
				user_str: user_str
			}
			this.$request.post(url, data).then(res => {
				let { code, message, data } = res;
				if(code == 200){
					this.giftVisible = false
					this.$message.success(message);

					this.getList({page: 1})
				}else{
					this.giftLoading = false
					this.$message.error(message);
				}
			});
		},
		getTableHeight(){
			if(this.tableHeight == 0){
				if(document.getElementById('tableHeight')){
					this.tableHeight = document.getElementById('tableHeight').clientHeight-120
				}
				console.log(this.tableHeight)
				if(this.tableHeight<=0){
					this.tableHeight = 300
				}
			}
		},
		deleteOk(){
			let data = { id: this.deleteId }
			let url = '?module=pc_api&action=coupon&app=del';
			this.deleteLoading = true
			this.$request.post(url, data).then(res => {
				let { code, message, data } = res;
				if(code == 200){
					this.deleteVisible = false
					this.$message.success(message);
					this.getList({page: 1})
				}else{
					this.$message.error(message);
				}
				this.loading = false
				this.deleteLoading = false
			});
		},
		delCoupon(id){
			this.deleteId = id
			this.deleteVisible = true
		},
		/**
		 * @name 路由跳转
		 */
		onNavJump(url){
		  this.$router.push(url)
		},
		onSave(){
			if(this.couponChecked&&!this.coupon_date){
				this.$message.error('优惠券过期删除天数不正确！')
				return
			}
			if(this.activeChecked&&!this.active_date){
				this.$message.error('优惠券活动过期删除天数不正确！')
				return
			}
			
			this.loading = true
			let data = {
				coupon_del: this.couponChecked?1:0,
				coupon_day: this.coupon_date,
				activity_del: this.activeChecked?1:0,
				activity_day: this.active_date,
				limit_type: this.checkRadio,
			};
			let url = '?module=pc_api&action=coupon&app=store_coupons_set';
			
			this.$request.post(url, data).then(res => {
				let { code, message, data } = res;
				if(code == 200){
					this.getConfig();
					this.$message.success(message);
				}else{
					this.$message.error(message);
				}
				this.loading = false
			});
		},
		radioChange(e){
			this.checkRadio = e.target.value
		},
		changeActive(checked){
			this.activeChecked = checked
		},
		changeCoupon(checked){
			this.couponChecked = checked
		},
		resetGoods() {
			this.coupon_type = undefined;
			this.is_end = undefined;
			this.coupon_name = '';
		},
		onSelectChange(selectedRowKeys, selectedRow) {
			this.selectedRowKeys = selectedRowKeys;
			this.selectedRow = selectedRow;
		},
		onSelectChangeM(selectedRowKeys, selectedRow) {
			this.selectedRowKeysM = selectedRowKeys;
			this.selectedRowM = selectedRow;

			
			let arr = JSON.parse(JSON.stringify(this.check_list))

			this.user_list.filter(items=>{
				let index = this.check_list.findIndex(item=>{
					return items.id == item.id
				})
				if(index>=0){
					this.check_list.splice(index,1)
				}
			})

			this.check_list.push(...selectedRow)
			
		},
		onChangeload(pagination) {
			this.getList({ page: pagination.current, ...pagination });
		},
		// 切换tab
		handCut(key){
		  this.activeKey = key+''
		  this.dataSource = []
		  let arr = ['getList','getConfig']
		  
		  if(key == 3){
		  	key = 1
		  }
		  this[arr[key-1]]({page: 1})
		},
		getConfig(){
			this.loading = true;
			
			let data = {};
			let url = '?module=pc_api&action=coupon&app=store_coupons_set_page';
			
			this.$request.post(url, data).then(res => {
				let { code, message, data } = res;
				
				if(data){
					this.couponChecked = data.coupon_del==1?true:false
					this.coupon_date = data.coupon_day
					this.activeChecked = data.activity_del==1?true:false
					this.active_date = data.activity_day
					this.checkRadio = Number(data.limit_type)
				}
				this.loading = false
			});
		},
		/**
		 * @name 请求列表
		 */
		getList(page = {}, current = 1) {
			this.loading = true;

			let data = {
				name: this.coupon_name,
				activity_type: this.coupon_type,
				status: this.is_end,
				...page
			};
			
			let url = '?module=pc_api&action=coupon&app=index';

			this.$request.post(url, data).then(res => {
				let { code, message, data } = res;
				if(code == 200){
					if(this.coupon_list.length == 0){
						this.coupon_list = data.coupon_type
					}
					
					this.dataSource = data.list
					
					let pages = {
					  total: data.total ,
					  current: page.page || current
					}
					this.pagination = pages
				}else{
					this.$message.error(message)
				}
				
				this.loading = false
			});
		}
	}
};
</script>
<style lang="less" >
.fund_manage {
	position: relative;
	height: 100%;
	.search {
		padding: 8px 32px;
	}

	.handle {
		padding: 0px 32px;
		padding-bottom: 8px;
		display: flex;
		align-items: center;
	}
	
	.ant-tabs{
		position: static;
		height: 100%;
		display: flex;
		flex-direction: column;
		
		.ant-tabs-top-content,.ant-tabs-bottom-content{
			flex: 1;
			
			.ant-tabs-tabpane{
				display: flex;
				flex-direction: column;
			}
		}
	}
	
	#tableHeight{
		flex: 1;
	}
	
}
.logistics {
	height: 600px;
	overflow: overlay;
	&-box {
		display: flex;

		&-right {
			padding-top: 6px;
		}
	}
}
.times {
	font-size: 14px;
	font-weight: 400;
	color: #969da8;
}

.templatepush {
	display: flex;
	align-items: baseline;
}

input[type='file'] {
	width: 72px;
	background: #e9ecef;
	outline: none;
	-webkit-appearance: button;
	-webkit-appearance: none;
	border-radius: 0;
}

.freight {
	margin-right: 20px;
}

.derive {
	height: 200px;
	display: flex;
	justify-content: space-around;
	align-items: center;
	> div {
		width: 100px;
		height: 100px;
		border: 1px solid #03a2f4;
		border-radius: 4px;
		color: #03a2f4;
		font-size: 14px;
		transition: background-color 0.5s;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-evenly;
		cursor: pointer;
	}

	> div:hover {
		border: 0px solid #03a2f4;
		color: #ffffff;
		background: #2890ff;
	}
}

.yuanquan {
	width: 16px;
	height: 16px;
	display: flex;
	border: 1px solid #ea4235;
	color: #ea4235;
	align-items: center;
	justify-content: center;
	border-radius: 999em;
	margin-right: 6px;
}

.dateBox{
	display: flex;
	align-items: center;
	width:460px;
	padding: 0 14px;
	height:64px;
	background:rgba(244,247,249,1);
	border-radius:4px;
	box-sizing: border-box;
	
	>div{
		width: 105px;
		margin: 0 5px;
	}
}

.ant-form-item{
	margin-bottom: 16px;
}

.foot{
	height: 68px;
	width: 100%;
	border-top: 1px solid #e9ecef;
	position: absolute;
	bottom: 0;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	padding: 0px 60px;
	background: #ffffff;
	z-index: 999;
}
.spinM{
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	top: 44px;
	z-index: 1111;
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: rgba(255,255,255,0.6);
}

a{
	color: #03A2F4;
}

.couponBox[class]{
	
	.ant-tabs-top-bar{
		margin-bottom: 0;
	}
	
	.search{
		padding: 20px;
	}
	
	.handle{
		padding: 0 20px 20px;
		
		.ant-btn{
			
		}
	}
}

.ant-tabs-nav .ant-tabs-tab{
	padding: 12px 0;
	margin: 0 20px;
}

.ant-tabs-nav .ant-tabs-tab-active{
	color: #03A2F4;
}

.ant-tabs-ink-bar{
	background-color: #03A2F4;
}

.ant-form-item-control{
	line-height: 36px;
}

.search{
	.ant-btn{
		font-size: 14px;
		font-family: Microsoft YaHei;
		color: #323544;
		background: #FFFFFF;
		border: 1px solid #828B97;
	}
	
	.ant-btn-primary[class]{
		color: #FFFFFF;
		background-color: #323544;
	}
}

.handleBox {
	a:not(:last-child){
		
	}
}


.giftMaskBox{
	display: flex;
	padding: 24px 16px 0 16px;

	&_left{
		line-height: 36px;
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #414658;

		.red{
			color: #FF0404;
		}

	}

	&_right{
		flex: 1;
		height: 100%;
		overflow: hidden;
		display: flex;
		flex-direction: column;

		.tabs{
			display: flex;
			width: 200px;
			height: 36px;

			div{
				display: flex;
				align-items: center;
				justify-content: center;
				flex: 1;
				background: #F4F7F8;
				border: 1px solid #D5DBE8;
				border-radius: 4px 0 0 4px;
				font-size: 14px;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #6A7076;
				cursor: pointer;
			}

			div:last-child{
				border-radius: 0 4px 4px 0;
			}

			.active{
				border: 0;
				background-color: #03A2F4;
				color: #ffffff
			}
		}

		.searchBox{
			display: flex;
			align-items: center;
			padding: 20px 0;

			.ant-btn-primary[class]{
				background-color: #323544;
			}

			.ant-select,.ant-input-affix-wrapper,.ant-btn{
				margin-right: 8px;
			}
		}

		.ant-table-pagination.ant-pagination{
			margin-right: 22px;
		}
	}

}

</style>
